import { postWithFailover, ERR, ERR_LABELS } from "../Common/apiClient";

export { ERR, ERR_LABELS };

async function postFormData(endpoint, pars, onProgress) {
  const formData = new FormData();
  Object.entries(pars).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return postWithFailover(endpoint, formData, { onProgress });
}

// Авторизация
export async function doLogin(pars, onProgress) {
  const loginParams = {
    email: pars.email,
    password: pars.password,
  };

  if (pars.referrer_id) {
    loginParams.referrer_id = pars.referrer_id;
  }

  return postFormData("/login", loginParams, onProgress);
}

// Восстановление пароля
export async function doForgetPassword(pars, onProgress) {
  return postFormData("/forgetpassword", {
    email: pars.email,
  }, onProgress);
}

// Сохранение настроек
export async function sendSettings(pars) {
  return postFormData("/setsettings", {
    user_id: pars.user_id,
    company_name: pars.company_name,
    language: pars.language,
    bank_name: pars.bank_name,
    bik: pars.bik,
    checking_account: pars.checking_account,
    correspondent_account: pars.correspondent_account,
    inn: pars.inn,
    kpp: pars.kpp,
  });
}

// Добавление токена (например, пуш-токен)
export async function addToken(pars) {
  return postFormData("/addtoken", {
    token: pars.token,
    v: pars.v,
  });
}
